<div class="ui-metric-cards tw:gap-app-3 tw:min-w-0"
  [class.ui-metric-cards-compact]="compact()"
  [class.ui-metric-cards-scroll-row]="scrollRow()">
  @for (item of items(); track item.key) {
    <article class="ui-metric-cards__item tw:flex tw:flex-col tw:gap-app-2 tw:min-w-0 tw:p-app-4"
      [class.ui-metric-cards__item--neutral]="item.tone === 'neutral'"
      [class.ui-metric-cards__item--success]="item.tone === 'success'"
      [class.ui-metric-cards__item--warning]="item.tone === 'warning'"
      [class.ui-metric-cards__item--danger]="item.tone === 'danger'">
      <span class="ui-metric-cards__label tw:text-app-muted tw:leading-app-normal">
        @if (item.label) {
          {{ item.label }}
        } @else {
          {{ item.labelKey | translate }}
        }
      </span>
      <strong class="ui-metric-cards__value tw:text-app-text tw:leading-app-snug tw:whitespace-nowrap">{{ item.value }}</strong>
      @if (item.detail) {
        <span class="ui-metric-cards__detail tw:text-app-muted tw:leading-app-normal">{{ item.detail }}</span>
      }
    </article>
  }
</div>
